<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/DHT3/DHT3.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">4DHT80/110 </div>
                <div class="detail-banner-desc transmission">Single-motor, dual-clutch, 4-speed DHT
                    <div class="detail-desc">
                        <div>
                            The motor utilizes a combined water-oil cooling system and Hairpin winding configuration, increasing the proportion of the high-efficiency operating range and boosting the overall motor system efficiency by 0.2% to 0.6%;<br />
                        </div>
                        <div>
                            A dual-clutch system is adopted to enable seamless gear shifts without interruption in power delivery throughout the vehicle;<br />
                        </div>
                        <div>
                            The four-speed design enhances the utilization of the engine efficient operating range and paired with the P4 rear axle, significantly improves the vehicle’s overall energy efficiency while balancing both performance and fuel economy.<br />
                        </div>

                    </div></div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">

                <div class="one-titile">
                    Core Configuration
                </div>

                <div class="spec-row">  
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-two">
                                    <div class="v">80kW@300V/110kW@580V</div>
                                    <div class="k">Peak Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">170N·m</div>
                                    <div class="k">Peak Torque</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">14000rpm</div>
                                    <div class="k">Maximum Speed</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2</div>
                                    <div class="k">Gear</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Water & oil cooling</div>
                                    <div class="k">Motor Cooling Type</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/DHT3/DHT3-2.jpg" alt="200-1-02">
                    </div>
                </div>

            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: '4DHT80/110 - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/transmission/DHT3.html'
};

import { createApp } from 'vue';
import App from './DHT3.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./DHT3.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
